export const sns = {
  line: {
    href: "https://lin.ee/4f3IfmZ",
  },
  x: {
    href: "https://x.com/miraima_app?s=21&t=SGEbUnYDtkqk8WFNgtXrbg",
  },
};
